var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveCasino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 65,
    viewBox: "0 0 58 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.9492 49.7203H27.793V51.817H29.9492V49.7203Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.9492 53.4774H27.793V55.5746H29.9492V53.4774Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.9492 57.2349H27.793V59.3321H29.9492V57.2349Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M57.7429 52.0432C57.7429 47.1088 54.1789 42.7428 49.0789 41.4262L36.7321 38.2238V34.3918C38.6527 32.5813 39.8522 30.1122 39.9154 27.3857C42.3737 27.2297 43.6714 25.417 43.6714 23.6061L43.6767 23.6052V13.7904C43.6767 6.18618 37.0353 0 28.8714 0C20.7076 0 14.0662 6.18618 14.0662 13.7904V23.6052C14.0662 25.6013 15.7282 27.2255 17.8275 27.3846C17.8905 30.1099 19.09 32.578 21.0108 34.3885V38.2238L8.66606 41.4257C3.56392 42.7428 0 47.1088 0 52.0432V64.2704H57.7429V52.0432ZM28.8724 41.3861L23.1671 38.4016V35.9712C24.8094 36.9006 26.8119 37.4559 28.8767 37.4559C30.9269 37.4559 32.944 36.9018 34.5758 35.981V38.4022L28.8724 41.3861ZM23.166 40.7044L26.671 42.5378L23.166 44.3708V40.7044ZM34.5779 40.7044V44.3708L31.074 42.5378L34.5779 40.7044ZM39.9306 25.3866V21.8237C41.093 21.9679 41.5152 22.8451 41.5152 23.6061C41.5152 24.3662 41.093 25.2429 39.9306 25.3866ZM28.8714 2.00845C35.8466 2.00845 41.5204 7.29387 41.5204 13.7904V20.2002C41.0914 19.9983 40.5605 19.8534 39.9254 19.8125C39.9057 13.0947 32.1109 11.6363 31.8889 11.5138C31.394 12.0026 29.0974 17.621 20.8087 17.621C20.5221 17.621 20.2463 17.615 19.9737 17.6061V16.4334H17.8175C17.8172 16.8916 17.8153 20.0061 17.8154 19.8268C17.2413 19.8719 16.7049 20.0247 16.2224 20.2686V13.7904C16.2224 7.29387 21.8963 2.00845 28.8714 2.00845ZM17.8122 25.3787C16.9099 25.2267 16.2224 24.4893 16.2224 23.6052C16.2224 22.7211 16.9099 21.9836 17.8122 21.8316V25.3787ZM19.9716 19.6172C20.2454 19.6255 20.5233 19.6295 20.8087 19.6295C26.1645 19.6295 30.0054 17.8059 32.826 13.9057C36.1088 15.0438 37.7712 17.0365 37.7712 19.8374V27.1626C37.7712 31.7183 33.7669 35.4475 28.8767 35.4475C24.1009 35.4475 19.9716 31.8299 19.9716 27.1626V19.6172ZM55.5866 62.2619H48.284V56.2327H46.1277V62.2619H11.6172V56.2327H9.46097V62.2619H2.15625V52.0432C2.15625 48.0081 5.0695 44.4384 9.24303 43.3611L21.0098 40.3093V46.0865C21.0098 46.4429 21.213 46.7729 21.5435 46.9529C21.711 47.0446 21.8994 47.0907 22.0879 47.0907C22.27 47.0907 22.4522 47.048 22.6154 46.9622L28.8724 43.6895L35.1286 46.9622C35.2917 47.048 35.4739 47.0907 35.656 47.0907C35.8445 47.0907 36.033 47.0446 36.2004 46.9534C36.531 46.7729 36.7342 46.4429 36.7342 46.0865V40.3095L48.5019 43.3616C52.6734 44.4384 55.5866 48.0081 55.5866 52.0432V62.2619Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.9817 21.4535H31.7412V23.4619H33.9817V21.4535Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.0012 21.4535H23.7607V23.4619H26.0012V21.4535Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31.2648 29.2784H26.4785V31.2868H31.2648V29.2784Z",
    fill: "#3C3C3C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCasino);
export default __webpack_public_path__ + "static/media/live-casino.d40c5cb9928ecee5155feaa90545d9ed.svg";
export { ForwardRef as ReactComponent };